module.exports = __webpack_public_path__ + "static/media/logotipo-azul.f234fd09.png";